import { useMutation } from "react-query";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useConfig } from "../../utils/useConfig";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { mutateSalarySacrifice } from "../../mutations/salarySacrifices/mutateSalarySacrifice";
import { useData } from "../../utils/useData";
import { toast } from "react-toastify";


export const useMutateSalarySacrifice = (options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employerId } = useData();

    return useMutation(async ({
        salarySacrificeId,
        code,
        reference
    }: {
        salarySacrificeId: string;
        code: string;
        reference: string;
    }) => {
        const { API_URL, token } = await getSafeSessionConfig(config, getToken);

        await mutateSalarySacrifice(
            API_URL,
            employerId,
            token,
            salarySacrificeId,
            code,
            reference
        )
    },
    {
        onSuccess: () => {
            toast.success(
                "Attempting to assign contribution - this can take up to 30 seconds"
            );
            options?.onSuccess?.();
        },
        onError: (error: Error) => {
            toast.error(error.message);
            options?.onError?.(error);
        }
    })
}